import { RedeemTemplateSubtype, RedeemType } from 'models/RedeemTemplate'

export enum InstoreRedemptionType {
  MANAGER_COMP = 'manager_comp',
  CASH_BACK = 'automatic_cash_back',
  COUPON_CODES = 'coupon_codes',
}

export type CategoryKeys =
  | 'free_item'
  | 'free_modifier'
  | 'discount'
  | 'buy_one_get_one'
  | 'buy_x_get_discount'
  | 'hidden_menu'
  | 'golden_ticket'
  | 'bonus_points'
  | 'delivery_discount'

export type RedeemTypeKeys =
  | 'get_a_free_item'
  | 'get_a_free_modifier'
  | 'get_%_off_purchase'
  | 'get_%_off_item'
  | 'get_$_off_purchase'
  | 'get_$_off_item'
  | 'any_item_for_$x'
  | 'any_modifier_for_$x'
  | 'free_fixed_price_item'
  | 'buy_x_get_%_off_purchase'
  | 'buy_item_get_%_off_item'
  | 'buy_x_get_$_off_purchase'
  | 'buy_item_get_$_off_item'
  | 'buy_one_get_free_one'
  | 'hidden_menu'
  | 'golden_ticket'
  | 'bonus_points'
  | 'delivery_discount'

export type RedeemTypeBase = {
  key: RedeemTypeKeys
  types: RedeemType[]
  subtype: RedeemTemplateSubtype | null
}

export type RedeemTypeItem = RedeemTypeBase

export type RedeemTypeModifier = RedeemTypeBase

export type RedeemCategory = {
  key: CategoryKeys
  forOrdering?: boolean
  items: RedeemTypeItem[]
  isNonDiscount?: boolean
  isDisabled?: boolean
  images?: string[]
}
